export default function getMarCodigo(mar_id) {
  switch (mar_id) {
      case 1:
        return 1
        break
      case 2:
        return 9
        break
      case 4:
        return 157
        break
      default:
        return null
        break
  } 
}